<template>
  <router-view
    :currentUser="currentUser" :teamId="teamId"
    v-on:preload-error="preloadFailed"
  />
</template>

<script>
import gql from 'graphql-tag'
import _indexOf from 'lodash-es/indexOf'

import { preload }  from '@/preloader'
import apolloProvider from '@/apolloProvider'

import CurrentUserQuery from '@/queries/CurrentUser.gql'
import LoadError from '@/components/LoadError.vue'

const VALID_LAYOUTS = ['singleton', 'sidebar-dual', 'sidebar-single', 'sidebar-single-frozen']

export default {
  components: {
    LoadError
  },

  props: ['teamId'],

  data() {
    return {
      currentUser: null,
      preloadErrors: []
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.preloadErrors = []
    next()
  },

  beforeRouteLeave(to, from, next) {
    this.preloadErrors = []
    next()
  },

  beforeRouteEnter: (to, from, next) => {
    const query = {
      query: CurrentUserQuery,
      fetchPolicy: 'network-only'
    }

    apolloProvider.defaultClient.query(query).then((response) => {
      let {data, errors} = response
      if(errors !== undefined) {
        if(errors[0].message == 'Not authorized') {
          next({name: 'login', meta: {redirect: to.path}})
        } else {
          next({name: 'login', meta: { redirect: to.path }})
        }
      } else {
        next(vm => vm.currentUser = response.data.currentUser)
      }
    }).catch((error) => {
      next({name: 'login', query: { redirect: to.path }})
    })
  },

  apollo: {
    $subscribe: {
      currentSession: {
        query: gql`
        subscription currentSession {
          currentSession {
            id
            deactivatedAt
          }
        }`,
        result(data) {
          alert("Your session has been logged out remotely.")
          this.$router.push({name: 'login'})
        }
      }
    },

    currentUser: {
      query: CurrentUserQuery,
      fetchPolicy: 'cache-first'
    }
  },

  methods: {
    preloadFailed(event) {
      this.preloadErrors.push(event)
    }
  }
}
</script>
